import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { localize, extend } from 'vee-validate';
import veeEn from 'vee-validate/dist/locale/en.json';
import veeKo from 'vee-validate/dist/locale/ko.json';
import * as rules from 'vee-validate/dist/rules';
import isURL from 'validator/lib/isURL';
import isMimeType from 'validator/lib/isMimeType';
import moment from 'moment';
import 'moment/locale/ko';
import i18nEn from './en';
import i18nKo from './ko';

// setup i18n
Vue.use(VueI18n);
export const i18n = new VueI18n({
  fallbackLocale: 'en',
  locale: 'en',
  messages: {
    en: i18nEn,
    ko: i18nKo,
  },
});

// setup vee validate
localize({
  en: veeEn,
  ko: veeKo,
});
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
const urlFixRule = (value) => isURL(value, { require_tld: true });
extend('url', urlFixRule);
export const vee = { localize };

// common setup
export default function setLocale(lang) {
  i18n.locale = lang;
  vee.localize(lang);
  moment.locale(lang);
}

window.$i18n = i18n;
window.$vee = vee;
window.$moment = moment;
window.$isURL = isURL;
window.$isMimeType = isMimeType;
